<template>
  <!-- <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div> -->
  <form @submit.prevent="handleFilters">
    <div class="row filter-row mb-3">
      <div v-if="!useIds" class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Job Title</label>
            <i
              v-if="filters.job_title"
              @click="handleClearOneFilter('job_title')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :options="jobs"
            v-model="filters.job_title"
            placeholder="Select Job Title"
            id="design3"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Requisition Status</label>
            <i
              v-if="filters.status"
              @click="handleClearOneFilter('status')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :options="employmentStatuses"
            placeholder="Select Status"
            id="design"
            v-model="filters.status"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Department</label>
            <i
              v-if="filters[departmentKey]"
              @click="handleClearOneFilter(departmentKey)"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :options="departments"
            v-model="filters[departmentKey]"
            placeholder="Select Department"
            id="design2"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0 text-truncate">
          <div class="filter-label-row">
            <label class="filter-label">Recruiter</label>
            <i
              v-if="filters[recruiterKey]"
              @click="handleClearOneFilter(recruiterKey)"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :options="recruiters"
            v-model="filters[recruiterKey]"
            placeholder="Select Recruiter"
            id="design4"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Priority</label>
            <i
              v-if="filters.priority"
              @click="handleClearOneFilter('priority')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :options="priorities"
            v-model="filters.priority"
            placeholder="Select Priority"
            id="design5"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <label class="filter-label">Month</label>
          <input
            type="month"
            class="form-control filter-input"
            v-model="filters.month"
          />
        </div>
      </div>
      <!-- <div class="col-sm-6 col-md-2">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocusedOn }"
        >
          <input
            type="text"
            class="form-control floating"
            v-model="filters.employee_name"
            @focus="isFocusedOn = true"
            @blur="isFocusedOn = employee_name !== ''"
          />
          <label class="focus-label">Employee Name</label>
        </div>
      </div> -->

      <!-- <div class="col-md-9"></div> -->
      <div class="d-flex align-items-end justify-content-end col-sm-6 col-md-12 gap-2 mt-1">
        <button
          type="submit"
          class="btn btn-filter"
          @click.prevent="handleFilters"
        >
          <i class="fa-solid fa-filter me-1"></i> Search
        </button>
        <button
          type="button"
          class="btn btn-reset"
          @click.prevent="resetAllFilters"
        >
          <i class="fa-solid fa-rotate-left me-1"></i> Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import EmploymentStatusService from "@/services/EmploymentStatusService";
import DepartmentService from "@/services/DepartmentService";
import EmployeeService from "@/services/EmployeeService";
import RecruitmentRequisitionService from "@/services/RecruitmentRequisitionService";
import DutyTypeService from "@/services/DutyTypeService";

export default {
  props: {
    useIds: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      select2: null,
      Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      filters: {
        month: "",
        status: "",
        [this.useIds ? "department_id" : "department_name"]: "",
        ...(this.useIds ? {} : { job_title: "" }),
        [this.useIds ? "assign_recruiter_id" : "assign_recruiter_name"]: "",
        priority: "",
        designation: "",
      },

      isFocusedOn: false,
      employmentStatuses: ["pending", "approved", "rejected", "publish"],
      departments: [],
      recruiters: [],
      jobs: [],
      priorities: ["low", "medium", "high"],
      searched: false,
    };
  },
  methods: {
    buildEmitPayload() {
      const payload = { ...this.filters };
      if (this.useIds && payload.status === "publish") {
        payload.status = "published";
      }
      return payload;
    },

    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit("apply-filters", this.buildEmitPayload());
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.buildEmitPayload());
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.buildEmitPayload());

      // Reset search state
      this.searched = false;
    },

    // async fetchEmploymentStatuses() {
    //   try {
    //     const response = await DutyTypeService.fetch();
    //     this.employmentStatuses = response?.data.map((el) => el.duty_type);
    //   } catch (error) {
    //     console.error("Error fetching employment statuses:", error);
    //   }
    // },
    async fetchRecruiters() {
      try {
        const response = await EmployeeService.getAllRecruiters();
        this.recruiters = this.useIds
          ? (response?.data || []).map((el) => ({ id: el.id, text: el.employee_name }))
          : response?.data.map((el) => el.employee_name);
      } catch (error) {
        console.error("Error fetching recruiters:", error);
      }
    },
    async fetchJobs() {
      try {
        const response = await RecruitmentRequisitionService.fetch();
        this.jobs = response?.data.map((el) => el.job_title);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },
    async fetchDepts() {
      try {
        const response = await DepartmentService.getDepartments();
        this.departments = this.useIds
          ? (response?.data || []).map((el) => ({ id: el.id, text: el.name }))
          : response?.data.map((el) => el.name);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        month: "",
        status: "",
        [this.departmentKey]: "",
        ...(this.useIds ? {} : { job_title: "" }),
        [this.recruiterKey]: "",
        priority: "",
      };
      this.searched = false;
    },
    async fetchServices() {
      try {
        // this.fetchEmploymentStatuses();
        this.fetchRecruiters();
        if (!this.useIds) {
          this.fetchJobs();
        }
        this.fetchDepts();
      } catch (error) {
        console.log("error fetching services", error);
      }
    },
  },
  created() {
    this.searched = false;
    this.fetchServices();
    // this.campaigns = (await CampaignService.getCampaigns())?.data.map(
    //   (el) => el.campaigns
    // );
    // this.projects = (await EmployeeProjectService.fetch())?.data.map(
    //   (el) => el.project_name
    // );
    // this.sections = (await SectionService.getSections())?.data.map(
    //   (el) => el.section_name
    // );

    // through ID
    // this.designations = (await DesignationService.getDesignations()).data.map(el => ({id: el.id, text: el.designation_name}));
    // this.divisions = (await DivisionService.getDivisions()).data.map(el => ({id: el.id, text:el.name}));

    // this.campaigns = (await CampaignService.getCampaigns()).data.map(el => ({id:el.id, text: el.campaigns}));
    // this.sections = (await SectionService.getSections()).data.map(el => ({id: el.id, text: el.section_name}));
  },

  computed: {
    departmentKey() {
      return this.useIds ? "department_id" : "department_name";
    },

    recruiterKey() {
      return this.useIds ? "assign_recruiter_id" : "assign_recruiter_name";
    },

    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>

<style scoped>
.filter-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.filter-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #878787;
  margin: 0 0 4px;
  padding: 0;
}

.filter-label-row .filter-label {
  margin: 0;
}

.filter-clear-icon {
  font-size: 10px;
  color: #8c9bb5;
  cursor: pointer;
  transition: color 0.2s ease;
}

.filter-clear-icon:hover {
  color: var(--primary-color);
}

:deep(.filter-input) {
  height: 36px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 12.5px;
  padding: 6px 12px;
  transition: all 0.2s ease;
}

:deep(.filter-input:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

:deep(.select2-container--default .select2-selection--single) {
  height: 36px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  transition: all 0.2s ease;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__rendered) {
  font-size: 12.5px !important;
  line-height: 34px !important;
  padding-left: 12px !important;
  padding-right: 30px !important;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__arrow) {
  height: 34px !important;
}

:deep(.select2-container--open .select2-selection--single) {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

.btn-filter {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  border-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  color: #ffffff;
}

.btn-reset {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-reset:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
  color: #303133;
}
</style>
